import { NgModule, CUSTOM_ELEMENTS_SCHEMA, forwardRef, Injectable } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpModule, XSRFStrategy, CookieXSRFStrategy, Http  } from '@angular/http';
import { HttpClientModule, HttpClientXsrfModule, HTTP_INTERCEPTORS  } from '@angular/common/http';

import { NglModule } from 'ng-lightning';

import { AppRoutingModule } from './app-routing.module';
import { MainRoutingModule } from './main/main-routing.module';
import { NotificationsRoutingModule } from './notifications/notifications-routing.module';
import { AdminRoutingModule } from './admin/admin-routing.module';
import { AccountsRoutingModule } from './admin/accounts/accounts-routing.module';
import { ReportsRoutingModule } from './reports/reports-routing.module';

import { AppComponent } from './app.component';
import { MainModule } from './main/main.module'
import { NotificationsModule } from './notifications/notifications.module'
import { LoginModule } from './login/login.module';
import { AppXSRF  } from './core/xsrf-strategy'
import { LoginService,UserProfileService, RaService, RvService, ProductRouteInfoService ,RvrsService, UsersService, ExcelImportService,NotificationService } from './core'
import { PrebuildLoginUserProfileService } from './core/prebuild-login-user-profile-service'
import { CustomersService } from './core/customers.service'
import { RateAuditSettingsService } from './core/rate-audit-settings.service'
import { PageNotFoundComponent } from './page-not-found.component';
import { DefaultsService } from './core/defaults.service'
import {BaseRequestOptions, RequestOptions} from '@angular/http';
import { RiHeaderModule } from './ri-header/ri-header.module';
import { CopyrightModule } from './common/component/copyright/copyright.module';
import { AdminModule } from './admin/admin.module';
import { ConfigurationModule} from './admin/configuration/configuration.module';
import { ReportsModule } from './reports/reports.module';
import { DownloadService } from './core/download.service';
import { AlertModule} from './common/component/alert/alert.module';
import { ModalModule } from './common/component/modal/modal.module';
import { SpinnerModule } from './common/component/spinner/spinner.module';
import { GDSCodeService } from './core/gds-code.service';
import { ConfirmDialogModule } from './common/component/confirm-dialog/confirm-dialog.module';
import { XsrfInterceptor } from './http-interceptors/xsrf-interceptor';



@Injectable()
export class MyOptions extends BaseRequestOptions {
  withCredentials: boolean = true;
}


@NgModule({
  imports: [
    BrowserAnimationsModule
    ,FormsModule
    ,HttpModule
    ,HttpClientModule
    ,HttpClientXsrfModule.withOptions({
      cookieName: 'XSRF-TOKEN',
      headerName: 'RequestVerificationToken',
    })
    ,CommonModule
    ,LoginModule
    ,RiHeaderModule
    ,CopyrightModule
    ,MainModule
    ,NotificationsModule
    ,AppRoutingModule

    ,AdminModule
    ,ConfigurationModule
    ,ReportsModule
    ,NglModule
    ,AlertModule
    ,ModalModule
    ,SpinnerModule
    ,ConfirmDialogModule
  ],
  providers: [
    XsrfInterceptor
    ,{provide: HTTP_INTERCEPTORS,useClass: XsrfInterceptor,multi: true}

    ,AppXSRF

    ,{provide: RequestOptions, useClass: MyOptions}

    , RaService
    , RvService
    , UserProfileService
    , PrebuildLoginUserProfileService
//    , { provide:UserProfileService, useExisting:forwardRef(() => LoginService) }
//    , { provide:LoginService, useExisting:forwardRef(() => TestDIForLogin) }
    ,LoginService
    ,ProductRouteInfoService
    ,DownloadService
    ,CustomersService
    ,RateAuditSettingsService
    ,DefaultsService
    ,GDSCodeService
    ,CustomersService
    ,RvrsService
    ,UsersService
    ,ExcelImportService
    ,NotificationService
  ],
  declarations: [
    AppComponent
    ,PageNotFoundComponent
  ],
  bootstrap:    [ AppComponent ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule {
  constructor(private first: PrebuildLoginUserProfileService){
    let x = first === first;
  }
}
/*
// AoT requires an exported function for factories
export function HttpLoaderFactory(http: Http) {
    return new TranslateHttpLoader(http, "i18n/", ".json");
}
*/
;
